import Vue from 'vue'
import App from './App'
import VuePerfectScrollbar from 'vue-perfect-scrollbar' //https://www.npmjs.com/package/vue-perfect-scrollbar
import vueVimeoPlayer from 'vue-vimeo-player' //https://www.npmjs.com/package/vue-vimeo-player
import * as VueGoogleMaps from 'vue2-google-maps' //https://www.npmjs.com/package/vue2-google-maps

import store from "./store.js";
import router from './router.js'

Vue.component('VuePerfectScrollbar', VuePerfectScrollbar);

Vue.use(vueVimeoPlayer);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDV96Jlc6uP0Ysqkvs4JCRfRdN7NkKCl6I',
    //libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js